"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SuccessIconStyled = exports.MailCircleIconStyled = exports.InfoIconStyled = exports.ContainerStyled = exports.CautionWarningIconStyled = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _CautionWarning = _interopRequireDefault(require("../../icons/CautionWarning"));
var _MailCircle = _interopRequireDefault(require("../../icons/MailCircle"));
var _Success = _interopRequireDefault(require("../../icons/Success"));
var _Information = _interopRequireDefault(require("../../icons/Information"));
var _styled = require("../constants/styled");
var ContainerStyled = exports.ContainerStyled = _styledComponents.default.div.withConfig({
  displayName: "AlertContainer__ContainerStyled",
  componentId: "sc-1qbkc5c-0"
})(["", ""], function (_ref) {
  var theme = _ref.theme;
  return "\n    left: 50%;\n    position: fixed;\n    transform: translateX(-50%);\n    width: 260px;\n    z-index: ".concat(theme.zIndex[9], ";\n\n    @media (min-width: ").concat(theme.breakpoint.lg.min, ") {\n      width: 420px;\n    }\n  ");
});
var CautionWarningIconStyled = exports.CautionWarningIconStyled = (0, _styledComponents.default)(_CautionWarning.default).attrs(function (_ref2) {
  var theme = _ref2.theme,
    type = _ref2.type;
  return {
    fill: type === 'success' ? theme.color.success : theme.color.dangerDark,
    kind: 'solid'
  };
}).withConfig({
  displayName: "AlertContainer__CautionWarningIconStyled",
  componentId: "sc-1qbkc5c-1"
})(["", " fill:", ";"], _styled.ICON_STYLES, function (_ref3) {
  var theme = _ref3.theme,
    type = _ref3.type;
  return type === 'success' ? theme.color.success : theme.color.dangerDark;
});
var MailCircleIconStyled = exports.MailCircleIconStyled = (0, _styledComponents.default)(_MailCircle.default).attrs(function (_ref4) {
  var theme = _ref4.theme;
  return {
    fill: theme.color.success
  };
}).withConfig({
  displayName: "AlertContainer__MailCircleIconStyled",
  componentId: "sc-1qbkc5c-2"
})(["", " fill:", ";"], _styled.ICON_STYLES, function (_ref5) {
  var theme = _ref5.theme;
  return theme.color.success;
});
var SuccessIconStyled = exports.SuccessIconStyled = (0, _styledComponents.default)(_Success.default).attrs(function (_ref6) {
  var theme = _ref6.theme;
  return {
    fill: theme.color.success,
    kind: 'solid'
  };
}).withConfig({
  displayName: "AlertContainer__SuccessIconStyled",
  componentId: "sc-1qbkc5c-3"
})(["", " fill:", ";"], _styled.ICON_STYLES, function (_ref7) {
  var theme = _ref7.theme;
  return theme.color.success;
});
var InfoIconStyled = exports.InfoIconStyled = (0, _styledComponents.default)(_Information.default).attrs(function (_ref8) {
  var theme = _ref8.theme;
  return {
    fill: theme.color.infoDark,
    kind: 'solid'
  };
}).withConfig({
  displayName: "AlertContainer__InfoIconStyled",
  componentId: "sc-1qbkc5c-4"
})(["", " fill:", ";"], _styled.ICON_STYLES, function (_ref9) {
  var theme = _ref9.theme;
  return theme.color.infoDark;
});